import { render, staticRenderFns } from "./inbound-voicemail-icon.vue?vue&type=template&id=4d90bd85"
import script from "./inbound-voicemail-icon.vue?vue&type=script&lang=js"
export * from "./inbound-voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports